import React from 'react';
import { FormattedMessage } from 'react-intl';
import { App, GQL } from '@gin-betting/core';

import globalMessages from 'messages';
import type { ListNavTab } from 'types';
import { CMS_LINKS, LocalRouts } from 'app-constants';
import FavoriteMobileLink from '../../views/HeaderMobile/FavoriteMobileLink';
import TopMobileTitle from '../../views/HeaderMobile/TopMobileTitle';
import MobileTopMenuLive from './components/MobileTopMenuLive';

// TODO: hardcode
export const overUnderMapping = {
    over: 'over',
    under: 'under',
    больше: 'over',
    меньше: 'under',
};

export const MOBILE_TABS: ListNavTab[] = [
    {
        title: React.createElement(FavoriteMobileLink),
        link: LocalRouts.FAVORITE_UPCOMING,
    },
    {
        title: React.createElement(TopMobileTitle),
        link: App.Routes.UPCOMING_LIST,
        isCreateButton: false,
    },
    {
        title: React.createElement(MobileTopMenuLive),
        link: App.Routes.LIVE_LIST,
    },
    {
        title: React.createElement(FormattedMessage, globalMessages.nextToGo),
        link: App.Routes.PREMATCH,
    },
    {
        title: React.createElement(FormattedMessage, globalMessages.outrights),
        link: App.Routes.OUTRIGHTS_LIST,
    },
    {
        title: React.createElement(FormattedMessage, globalMessages.results),
        link: App.Routes.RESULTS_LIST,
    },
];

export const STATISTIC_TAB = {
    title: React.createElement(FormattedMessage, globalMessages.statistics),
    link: CMS_LINKS.STATISTIC,
};
